import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getNumberOfAgentsSoonLoggedInToOneOrManyQueues } from 'flow/selectors/extension-selectors';
import SupervisorTotalContainer from 'flow/components/pbx/supervisor/sub-components/SupervisorTotalContainer';
import { selectSelectedQueues } from './SupervisorOverviewSelectors';

const AgentsLoggedInSoonItem = () => {
    const selectedQueues = useAppSelector(selectSelectedQueues);
    const number = useAppSelector((state) =>
        //@ts-ignore This selector seems to take two arguments, but ts believes it only takes one.
        getNumberOfAgentsSoonLoggedInToOneOrManyQueues(state, selectedQueues),
    );
    return (
        <SupervisorTotalContainer
            colorType={'gray-400'}
            iconType={'timelapse'}
            label={number}
        />
    );
};

export default AgentsLoggedInSoonItem;
